"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const I18n_1 = __importDefault(require("./vendor/I18n"));
const lodash_1 = __importDefault(require("lodash"));
require("bootstrap");
window.__ = new I18n_1.default();
window.translations = {};
window._ = lodash_1.default;
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
    // window.Popper = popper
    // window.$ = window.jQuery = require('jquery')
}
catch (e) {
    console.error(e);
}
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = axios_1.default;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common.Accept = 'application/json';
window.axios.defaults.withCredentials = true;
window.axios.interceptors.response.use((response) => {
    const replyStatus = _.has(response, 'data.replyStatus') && _.get(response, 'data.replyStatus.status');
    if (replyStatus && replyStatus !== 'OK') {
        const customError = new Error(_.get(response, 'data.replyStatus.errorMessage'));
        response.original_status = response.status;
        response.status = 500;
        response.statusText = 'ERROR';
        customError.response = response;
        return Promise.reject(customError);
    }
    return response;
}, (error) => {
    console.error('rejected');
    return Promise.reject(error.response);
});
// window.axios
//   .get('/api/translations')
//   .then((response) => response.data)
//   .then((translations) => {
//     window.translations = translations
//   })
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
// import Echo from 'laravel-echo';
// window.Pusher = require('pusher-js');
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
